module.exports = __webpack_public_path__ + "img/pending-status.56fd73e2.svg";